
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"19","viewBox":"0 0 55 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.544 18.048c0-5.536.992-9.872 2.976-13.008C5.536 1.904 8.864.336 13.504.336s7.952 1.568 9.936 4.704c2.016 3.136 3.024 7.472 3.024 13.008 0 5.568-1.008 9.936-3.024 13.104-1.984 3.168-5.296 4.752-9.936 4.752S5.536 34.32 3.52 31.152C1.536 27.984.544 23.616.544 18.048zm19.296 0c0-2.368-.16-4.352-.48-5.952-.288-1.632-.896-2.96-1.824-3.984-.896-1.024-2.24-1.536-4.032-1.536-1.792 0-3.152.512-4.08 1.536-.896 1.024-1.504 2.352-1.824 3.984-.288 1.6-.432 3.584-.432 5.952 0 2.432.144 4.48.432 6.144.288 1.632.896 2.96 1.824 3.984.928.992 2.288 1.488 4.08 1.488 1.792 0 3.152-.496 4.08-1.488.928-1.024 1.536-2.352 1.824-3.984.288-1.664.432-3.712.432-6.144zm13.847 10.368c3.072-2.56 5.52-4.688 7.344-6.384 1.824-1.728 3.344-3.52 4.56-5.376 1.216-1.856 1.824-3.68 1.824-5.472 0-1.632-.384-2.912-1.152-3.84-.768-.928-1.952-1.392-3.552-1.392s-2.832.544-3.696 1.632c-.864 1.056-1.312 2.512-1.344 4.368h-6.528c.128-3.84 1.264-6.752 3.408-8.736C36.727 1.232 39.48.24 42.807.24c3.648 0 6.448.976 8.4 2.928 1.952 1.92 2.928 4.464 2.928 7.632 0 2.496-.672 4.88-2.016 7.152-1.344 2.272-2.88 4.256-4.608 5.952-1.728 1.664-3.984 3.68-6.768 6.048h14.16v5.568H31.191v-4.992l2.496-2.112z","fill":"#000"}})])
          )
        }
      }
    